import * as RadixMenu from '@radix-ui/react-dropdown-menu';
import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export const Menu = RadixMenu.Root;
export const MenuTrigger = RadixMenu.Trigger;

export function MenuContent({
  children,
  align = 'start',
  className,
}: {
  children: ReactNode;
  align?: 'start' | 'center' | 'end';
  className?: string;
}) {
  return (
    <RadixMenu.Portal>
      <RadixMenu.Content
        align={align}
        sideOffset={4}
        collisionPadding={8}
        // Le menu vit dans un portail : on évite que le clic remonte jusqu'à la carte (qui ouvrirait la note).
        onClick={(event) => event.stopPropagation()}
        className={cn(
          'animate-fade-in z-[60] min-w-44 rounded bg-menu py-1.5 text-sm text-fg shadow-dialog',
          className,
        )}
      >
        {children}
      </RadixMenu.Content>
    </RadixMenu.Portal>
  );
}

export function MenuItem({
  children,
  onSelect,
  disabled,
}: {
  children: ReactNode;
  onSelect: (event: Event) => void;
  disabled?: boolean;
}) {
  return (
    <RadixMenu.Item
      disabled={disabled}
      onSelect={onSelect}
      className="flex h-8 cursor-pointer items-center px-4 outline-none select-none data-[disabled]:opacity-40 data-[highlighted]:bg-hover"
    >
      {children}
    </RadixMenu.Item>
  );
}
